/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_WebhookInputs */

const cs_action_webhook = /** @type {(inputs: Action_WebhookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook`)
};

const en_action_webhook = /** @type {(inputs: Action_WebhookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook`)
};

/**
* | output |
* | --- |
* | "Webhook" |
*
* @param {Action_WebhookInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_webhook = /** @type {((inputs?: Action_WebhookInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_WebhookInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_webhook(inputs)
	return cs_action_webhook(inputs)
});